import type { CSSProperties } from 'react';
import type { ProjectFlagStage } from '@/api/client';

/** Цвета стадий отметок — цвета этапов: красная, жёлтая — свой токен (--flag-warn), палитра этапов её не задевает, зелёная как «Готов»; серая (0) — без цвета */
export const FLAG_STAGE_COLOR_VAR: Record<Exclude<ProjectFlagStage, 0>, string> = {
  1: 'var(--destructive)',
  2: 'var(--flag-warn)',
  3: 'var(--stage-done)',
};

/** Цвет стадии в --c (заливки ячейки и полосы); у серой его нет */
export function flagStageStyle(stage: ProjectFlagStage): CSSProperties | undefined {
  return stage === 0 ? undefined : ({ '--c': FLAG_STAGE_COLOR_VAR[stage] } as CSSProperties);
}

/**
 * Ячейка отметки (концепт flag-tab-hover 1.2): заливка 40 % цвета — как выбранная стадия в попапе, подпись темнее, 45 %
 * (при 70 %, как в попапе, жёлтая и зелёная читались хуже прежних). Серая — фон обложки (muted, #f5f5f5) и бледная подпись.
 * Заливка — в --flag-bg: ею же тает начало названия у края карточки.
 */
export const FLAG_TINT =
  'nd:[--flag-bg:color-mix(in_oklab,var(--c)_40%,var(--card))] nd:bg-(--flag-bg) nd:text-[color-mix(in_oklab,var(--c)_45%,var(--foreground))]';
export const FLAG_EMPTY = 'nd:[--flag-bg:var(--muted)] nd:bg-(--flag-bg) nd:text-foreground/30';
/** Полоса стадий в попапе ярче ячеек: сегмент — 24 % цвета, выбранный — 40 % (серая выбранная — 12 % текста) */
const FLAG_STRIP_TINT = 'nd:bg-[color-mix(in_oklab,var(--c)_24%,var(--card))] nd:text-[color-mix(in_oklab,var(--c)_60%,var(--foreground))]';
const FLAG_STRIP_TINT_SELECTED = 'nd:bg-[color-mix(in_oklab,var(--c)_40%,var(--card))] nd:text-[color-mix(in_oklab,var(--c)_70%,var(--foreground))]';
const FLAG_STRIP_EMPTY_SELECTED = 'nd:bg-[color-mix(in_oklab,var(--foreground)_12%,var(--card))] nd:text-foreground/60';

export function flagToneClass(stage: ProjectFlagStage): string {
  return stage === 0 ? FLAG_EMPTY : FLAG_TINT;
}

/** Сегмент полосы стадий в попапе */
export function flagStripToneClass(stage: ProjectFlagStage, selected: boolean): string {
  if (stage === 0) return selected ? FLAG_STRIP_EMPTY_SELECTED : FLAG_EMPTY;
  return selected ? FLAG_STRIP_TINT_SELECTED : FLAG_STRIP_TINT;
}
